import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Checkbox, FormControlLabel, FormHelperText, Typography } from '@mui/material';

import { flattenCategoryTree } from '../../../utils/categoryTree';

// Lista de categorias en arbol con casillas (como en WordPress): cada subcategoria va debajo de
// su padre con sangria y se pueden marcar varias. `value` es el arreglo de ids marcados.
export default function CategoryChecklist({ categories, value, onChange, error, helperText }) {
  const tree = useMemo(() => flattenCategoryTree(categories), [categories]);

  const toggle = (categoryId) => {
    const checked = value.includes(categoryId)
      ? value.filter((id) => id !== categoryId)
      : [...value, categoryId];
    // Se envian en el orden del arbol: si se desmarca la principal, la primera marcada pasa a serlo.
    onChange(tree.filter((category) => checked.includes(category.id)).map((category) => category.id));
  };

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 0.5 }} color={error ? 'error' : 'text.primary'}>
        Categorías
      </Typography>
      <Box
        sx={{
          border: 1,
          borderColor: error ? 'error.main' : 'divider',
          borderRadius: 1,
          maxHeight: 240,
          overflowY: 'auto',
          py: 0.5,
        }}
      >
        {tree.length === 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ px: 2, py: 1 }}>
            No hay categorías registradas.
          </Typography>
        )}
        {tree.map((category) => (
          <FormControlLabel
            key={category.id}
            sx={{ display: 'flex', mx: 0, pl: 1 + category.depth * 3 }}
            control={
              <Checkbox size="small" checked={value.includes(category.id)} onChange={() => toggle(category.id)} />
            }
            label={
              <Typography variant="body2" sx={{ fontWeight: category.depth === 0 ? 600 : 400 }}>
                {category.name}
              </Typography>
            }
          />
        ))}
      </Box>
      <FormHelperText error={error}>{helperText}</FormHelperText>
    </Box>
  );
}

CategoryChecklist.propTypes = {
  categories: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.node,
};

CategoryChecklist.defaultProps = {
  error: false,
  helperText: undefined,
};
